import React, {useRef} from "react";
import text from "strings/text";
import { useIntl } from 'react-intl';
import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import './TeamProfile.scss';
import presenter from "./duck/presenter";
import { useState } from "react";
import displayLogic from "./duck/displayLogic";
import factory from "./duck/factory";
import RemoveItemModal from "components/RemoveItemModal";
import RemoveUserModal from "./RemoveUserModal";
import ModalOverlay from "components/ModalOverlay";
import {Mixpanel} from "helpers/Mixpanel";

export function UserBioComponent({ userPrivilege, updateUserProfileDispatch, updateUserPrivilegeDispatch, removeAvatarDispatch, removeUserPrivilegeDispatch }) {
    const intl = useIntl();

    const [isInEditMode, setIsInEditMode] = useState(false)
    const [showRemovePhotoModal, setShowRemovePhotoModal] = useState(false)
    const [showRemoveUserModal, setShowRemoveUserModal] = useState(false)

    const nameInputRef = useRef(null)
    const emailInputRef = useRef(null)
    const phoneInputRef = useRef(null)
    const jobTitleInputRef = useRef(null)
    const employeeIDInputRef = useRef(null)
    const accessLevelButtonRef = useRef(null)


    const resetInputFields = () => {
        nameInputRef.current.value = presenter.getFullName(userPrivilege)
        emailInputRef.current.value = presenter.getEmail(userPrivilege)
        phoneInputRef.current.value = presenter.getPhone(userPrivilege)
        jobTitleInputRef.current.value = presenter.getJobTitle(userPrivilege)
        employeeIDInputRef.current.value = presenter.getEmployeeID(userPrivilege)
        accessLevelButtonRef.current.innerText = intl.formatMessage(presenter.getAccessLevelText(userPrivilege))
    } 

     const handleSaveClick = () => {
        const userPayload = factory.createUserPayload(nameInputRef, emailInputRef, phoneInputRef, userPrivilege);
        const userPrivilegePayload = factory.createUserPrivlegePayload(accessLevelButtonRef, jobTitleInputRef, employeeIDInputRef, userPrivilege, intl.formatMessage(presenter.getAccessLevelText(userPrivilege)), intl.formatMessage(text.adminIntl), intl.formatMessage(text.teamMemberIntl));

        if(  Object.keys(userPayload).length > 0 ) {
            updateUserProfileDispatch(userPrivilege.userPrivilege.owner_id, userPayload);
            Mixpanel.track('Update User Profile');
        }

        if(  Object.keys(userPrivilegePayload).length > 0 ) {
            updateUserPrivilegeDispatch(userPrivilege.userPrivilege.id, userPrivilegePayload);
            Mixpanel.track('Update User Priv Profile');
        }
        setIsInEditMode(false);
    }

    const handleDeleteAvatarClick = () => { setShowRemovePhotoModal(true); }

    const removeProfilePhoto = () => {
        removeAvatarDispatch(userPrivilege.userPrivilege.owner_id);
        setShowRemovePhotoModal(false);
    }

    const handleRemoveUserClick = () => { setShowRemoveUserModal(true); }

    const goBack = () => { window.history.back(); }

    const removeUser = () => { 
        removeUserPrivilegeDispatch(userPrivilege.userPrivilege.id, goBack) 
        Mixpanel.track('Remove User From Profile');
    }

    const handleEditClick = () => {
        setIsInEditMode(!isInEditMode);
    }

    const handleCancelClick = () => {
        // Cancel logic here
        setIsInEditMode(false);
        resetInputFields();
    }

    const handleAdminClick= () => {
        accessLevelButtonRef.current.innerText = intl.formatMessage(text.adminIntl);
    }

    const handleTeamMemberClick = () => {
        accessLevelButtonRef.current.innerText = intl.formatMessage(text.teamMemberIntl);
    }

    const showEmailNotVerified = displayLogic.shouldShowEmailNotVerified(userPrivilege);
    const showPhoneNotVerified= displayLogic.shouldShowPhoneNotVerified(userPrivilege);
    const showNotVerifiedRow = (showEmailNotVerified || showPhoneNotVerified);
    const canEditEmail = displayLogic.canEditUserEmail(isInEditMode, userPrivilege);
    const canEditPhone = displayLogic.canEditUserPhoneNumber(isInEditMode, userPrivilege);
    const emailClassNames = presenter.classNamesForHalfField(displayLogic.shouldGreyOutEmailField(isInEditMode, canEditEmail));
    const phoneClassNames = presenter.classNamesForHalfField(displayLogic.shouldGreyOutPhoneField(isInEditMode, canEditPhone));

    return (
        <div className="user-bio">
            <label className="section-label">{text.employeeInformation}</label>
            <label className="info-label">{text.profilePhoto} </label>
            <div className="photo-wrap">
                <img className="profile-photo" src={presenter.getAvatar(userPrivilege)}/>
                { displayLogic.shouldShowDeleteAvatarButton(isInEditMode, userPrivilege) && <button className="delete-photo" onClick={handleDeleteAvatarClick}><img src="/icons/delete-corner.svg"/></button> }
            </div>

            <label className="info-label">{text.fullName}</label>
            <input ref={nameInputRef} disabled={!isInEditMode} className="full-field" type="text" placeholder={intl.formatMessage(text.firstLastNameIntl)} defaultValue={presenter.getFullName(userPrivilege)} />

            <div className="bio-row">
                <div className="leading-half">
                    <label className="info-label">{text.email}</label>
                    <input ref={emailInputRef} disabled={!canEditEmail} className={emailClassNames} placeholder={intl.formatMessage(text.companyEmailIntl)} defaultValue={presenter.getEmail(userPrivilege)}></input>
                </div>

                <div className="trailing-half">
                    <label className="info-label">{text.phone}</label>
                    <input ref={phoneInputRef} disabled={!canEditPhone} className={phoneClassNames} placeholder={intl.formatMessage(text.phoneIntl)} defaultValue={presenter.getPhone(userPrivilege)}></input>
                </div>
            </div>

            {showNotVerifiedRow && 
            <div className="bio-row">
                <div className="leading-half">
                    {showEmailNotVerified && <label className="unverified">{text.notVerified}</label>}
                </div>
                <div className="trailing-half">
                    {showPhoneNotVerified && <label className="unverified">{text.notVerified}</label>}
                </div>
            </div>}


            <div className="bio-row">
                <div className="leading-half">
                    <label className="info-label">{text.jobTitle}</label>
                    <input ref={jobTitleInputRef} disabled={!isInEditMode}  className="half-field" placeholder={intl.formatMessage(text.jobTitleIntl)} defaultValue={presenter.getJobTitle(userPrivilege)}></input>
                </div>

                <div className="trailing-half">
                    <label className="info-label">{text.employeeID}</label>
                    <input ref={employeeIDInputRef} disabled={!isInEditMode} className="half-field" placeholder={intl.formatMessage(text.enterEmployeeIDIntl)} defaultValue={presenter.getEmployeeID(userPrivilege)}></input>
                </div>
            </div>

            <div className="bio-row">
                <div className="leading-half">
                    <label className="info-label">{text.accessLevel}</label>
                    <button ref={accessLevelButtonRef} disabled={!isInEditMode} id='accessLevelDropdown' className={presenter.classNamesForAccessLevelButton(isInEditMode)} data-bs-toggle="dropdown" aria-expanded="false">{intl.formatMessage(presenter.getAccessLevelText(userPrivilege)) } </button>
                    <ul className="dropdown-menu access-level" aria-labelledby="accessLevelDropdown">
                        <li className="dropdown-li" onClick={() => handleAdminClick()}> <label> {text.admin} </label><br/> </li>
                        <li className="dropdown-li" onClick={() => handleTeamMemberClick()}> <label> {text.teamMember} </label><br/> </li>
                    </ul>
                </div>

                <div className="trailing-half">
                    <label className="info-label">{text.status}</label>
                    <input disabled={true} className="half-field" placeholder={intl.formatMessage(text.unregisteredIntl)} defaultValue={presenter.getStatusText(userPrivilege)} />
                </div>
            </div>

            <div className="bio-row btn-row">
                <div className="leading-half">
                 { displayLogic.shouldShowRemoveUserButton(isInEditMode) &&  <button className="red-btn" onClick={handleRemoveUserClick}>{text.removeUser}</button> }
                 { displayLogic.shouldShowInviteUserButton(isInEditMode, userPrivilege) && <button className="blue-btn">{text.inviteUser}</button> }
                </div>
                <div className="btn-group">
                   { displayLogic.shouldShowEditButton(isInEditMode) && <button className="cancel-style" onClick={handleEditClick}>{text.edit}</button> }
                   { displayLogic.shouldShowCancelButton(isInEditMode) && <button className="cancel-style" onClick={handleCancelClick}>{text.cancel}</button> }
                   { displayLogic.shouldShowSaveButton(isInEditMode) &&  <button className="confirm-style btn-elem" onClick={handleSaveClick}>{text.save}</button> }
                </div>
            </div>

            { showRemovePhotoModal && <RemoveItemModal removeItem={removeProfilePhoto} closeModal={() => setShowRemovePhotoModal(false)} title={text.removePhotoTitle} explain={text.removePhotoExplain} /> }
            { showRemoveUserModal && <RemoveUserModal removeUser={removeUser} name={presenter.getFullName(userPrivilege)} closeModal={() => setShowRemoveUserModal(false)} /> }
            { (showRemovePhotoModal || showRemoveUserModal) && <ModalOverlay/> }
        </div>
    )
}

export default UserBioComponent;